// Auto-generated by tools/avatar/generate-accessory-svgs.mjs
 
import type { RecordOfAccessoryComponents } from './types'

import KurtSvg from './kurt.svg?raw'
import Prescription01Svg from './prescription-01.svg?raw'
import Prescription02Svg from './prescription-02.svg?raw'
import RoundSvg from './round.svg?raw'
import SunglassesSvg from './sunglasses.svg?raw'
import WayfarersSvg from './wayfarers.svg?raw'

export const accessoryComponents = {
  Blank: '',
  Kurt: KurtSvg,
  Prescription01: Prescription01Svg,
  Prescription02: Prescription02Svg,
  Round: RoundSvg,
  Sunglasses: SunglassesSvg,
  Wayfarers: WayfarersSvg,
} satisfies RecordOfAccessoryComponents

export type AccessoryComponentName = keyof typeof accessoryComponents
